import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ApprovalFlow} from './approval-flow.model';
import * as ApprovalFlowActions from './approval-flow.actions';

export const approvalFlowsFeatureKey = 'approvalFlows';

export interface State extends EntityState<ApprovalFlow> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ApprovalFlow> = createEntityAdapter<ApprovalFlow>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ApprovalFlowActions.addApprovalFlow,
    (state, action) => adapter.addOne(action.approvalFlow, state)
  ),
  on(ApprovalFlowActions.upsertApprovalFlow,
    (state, action) => adapter.upsertOne(action.approvalFlow, state)
  ),
  on(ApprovalFlowActions.addApprovalFlows,
    (state, action) => adapter.addMany(action.approvalFlows, state)
  ),
  on(ApprovalFlowActions.upsertApprovalFlows,
    (state, action) => adapter.upsertMany(action.approvalFlows, state)
  ),
  on(ApprovalFlowActions.updateApprovalFlow,
    (state, action) => adapter.updateOne(action.approvalFlow, state)
  ),
  on(ApprovalFlowActions.updateApprovalFlows,
    (state, action) => adapter.updateMany(action.approvalFlows, state)
  ),
  on(ApprovalFlowActions.deleteApprovalFlow,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ApprovalFlowActions.deleteApprovalFlows,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ApprovalFlowActions.loadApprovalFlows,
    (state, action) => adapter.setAll(action.approvalFlows, state)
  ),
  on(ApprovalFlowActions.clearApprovalFlows,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
